import React from 'react'
import Popup from 'reactjs-popup'
import { useSelector } from 'react-redux'
import styles from './styles.module.scss'

function TooltipWrapper({ triggerElement, content, contentStyle, position = 'top center', className, ...rest }) {
  const {
    common: { isNative }
  } = useSelector((state) => state)

  return (
    <Popup
      className={`tootipContainer ${className}`}
      contentStyle={contentStyle}
      trigger={<div>{triggerElement}</div>}
      position={position}
      on={isNative ? [] : ['hover', 'focus']}
      arrow={position !== 'center center'}
      {...rest}>
      <div className={styles.content}> {content}</div>
    </Popup>
  )
}

export default TooltipWrapper
